import React from "react";
import PropTypes from "prop-types";

const ErrorInput = ({ touched, error }) => {
  if (touched && error) {
    return (
      <div className="d-inline-flex align-items-center">
        <span
          className="badge rounded-pill bg-danger fw-semibold"
          style={{ fontSize: "0.68rem", padding: "0.3em 0.6em", lineHeight: "1" }}
        >
          {error}
        </span>
      </div>
    );
  }
  return null;
};

ErrorInput.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default ErrorInput;
